import { PlainIconButton } from "@tvg/fuse-buttons";
import styled from "styled-components";
import {
  FocusCss,
  borderRadiusConfig,
  ScreenReaderOnlyCss,
} from "@tvg/fuse-utils";
import { styledInputConfig } from "./configs";

const { borderRadius, borderWidth, componentName } = styledInputConfig;

const StyledForm = styled.form.attrs({
  className: componentName,
})`
  width: 100%;

  &.fuse-input--disabled div {
    background-color: unset;
  }

  &.fuse-input--disabled label,
  &.fuse-input--disabled span,
  &.fuse-input--disabled p,
  &.fuse-input--disabled input {
    color: var(--color-global-grey400);
  }

  &.fuse-input--disabled button {
    color: var(--color-global-grey400);

    &:hover,
    &:focus,
    &:active {
      outline: none;
      cursor: initial;
    }
  }

  &.fuse-input--disabled div,
  &.fuse-input--disabled input {
    border-color: var(--color-global-grey400);
    background-color: unset;
  }

  &.fuse-input--disabled .${componentName}__input-icon {
    background-color: var(--color-global-grey400);
  }
`;

const StyledLabel = styled.label.attrs({
  className: `${componentName}__label`,
})`
  ${ScreenReaderOnlyCss}
`;

const StyledInputContainer = styled.div.attrs({
  className: `${componentName}__input-container`,
})`
  background: var(--color-global-white);

  align-items: center;
  border: ${borderWidth} solid var(--color-global-grey400);
  color: var(--color-global-enhancedText);
  display: flex;
  font-size: var(--font-size-1);
  line-height: var(--font-line-height-1);
  overflow: hidden;
  width: 100%;
  height: var(--spacing-space48);

  ${borderRadius};

  &:hover {
    border-color: var(--color-global-grey700);
  }

  &:focus-within {
    border-color: var(--color-brand-mid);
  }

  &.${componentName}__input-container--outline {
    ${FocusCss}
  }
`;

const StyledInput = styled.input.attrs({
  className: `${componentName}__input`,
})`
  border: none;
  color: var(--color-global-grey900);
  flex: 1 1 auto;
  font-size: var(--font-line-heading1);
  outline: none;
  width: 100%;
  padding: var(--spacing-space8) var(--spacing-space12);
  padding-right: var(--spacing-space48);

  /* Firefox */
  -moz-appearance: textfield;

  /* Removes the built-in eye-icon for MS Edge */
  &::-ms-reveal {
    display: none;
  }

  &::placeholder {
    color: var(--color-global-black);
  }
`;

const StyledPlainIconButton = styled(PlainIconButton)`
  background-color: var(--color-brand-mid);
  width: var(--spacing-space48);
  height: var(--spacing-space48);
  border-radius: 0 ${borderRadiusConfig.l} ${borderRadiusConfig.l} 0;
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover .fuse-plain-icon-button__icon,
  &:focus .fuse-plain-icon-button__icon {
    background: ${({ color }) => color};
  }
`;

export {
  StyledForm,
  StyledInput,
  StyledInputContainer,
  StyledLabel,
  StyledPlainIconButton,
};
